import React from "react";
import { statusCategories } from "../../../Findings/FindingDetailsPane/FindingDetailsPaneHeader/Statuses/StatusUtils";
import PieChart from "../PieChart";
import type { SelectedScope } from "../../../types/scope";

interface FindingsByCategoryProps {
  selectedScope?: SelectedScope | null;
  filterToExecute?: string | null;
  scopeToExecute?: string | null;
  id: string;
  setIsReadyToExport?: ((isReady: boolean) => void) | null;
}

const FindingsByCategory: React.FC<FindingsByCategoryProps> = ({
  selectedScope,
  filterToExecute,
  scopeToExecute,
  id,
  setIsReadyToExport,
}) => {
  const filtersConfig = {
    filtersjson: filterToExecute || null,
    scopesjson: scopeToExecute || null,
    scopesid: selectedScope?.value?.id,
  };

  const chartFilterValue = [
    {
      type: "category",
      key: statusCategories.OPEN,
      id: statusCategories.OPEN,
    },
  ];

  const skip =
    (!scopeToExecute && !selectedScope?.value?.id) || !filterToExecute;

  const chartName = `findings-by-category-div-${id}`;

  return (
    <PieChart
      categories={null}
      skip={skip}
      groupBy={["finding.category"]}
      filtersConfig={filtersConfig}
      legendTitle={"Category"}
      chartName={chartName}
      chartFilterValue={chartFilterValue}
      actualFilterField={"category"}
      dataSubject={"Findings"}
      setIsReadyToExport={setIsReadyToExport}
    />
  );
};

export default FindingsByCategory;
